import React, { useEffect, useState } from "react";
import { CheckCircle2, AlertTriangle, X } from "lucide-react";

const STORAGE_KEY = "eviq_tesla_session_id";

/**
 * TeslaConnectBanner
 * Shown when the user returns from Tesla OAuth with ?tesla=connected|error.
 * Persists the session_id so subsequent visits know the account is linked.
 */
export const TeslaConnectBanner = () => {
  const [state, setState] = useState(null); // {type: "success"|"error", detail}

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tesla = params.get("tesla");
    if (tesla === "connected") {
      const sid = params.get("session_id");
      if (sid) localStorage.setItem(STORAGE_KEY, sid);
      setState({ type: "success", sessionId: sid });
      // Clean URL
      window.history.replaceState({}, "", window.location.pathname);
    } else if (tesla === "error") {
      setState({ type: "error", reason: params.get("reason") || "unknown" });
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, []);

  if (!state) return null;

  const isSuccess = state.type === "success";
  const Icon = isSuccess ? CheckCircle2 : AlertTriangle;
  const color = isSuccess ? "#39FF14" : "#FFB020";

  return (
    <div
      data-testid="tesla-connect-banner"
      className="fixed top-4 right-4 z-[90] max-w-sm rounded-2xl border bg-black/95 backdrop-blur-md p-4 shadow-2xl"
      style={{ borderColor: `${color}55` }}
    >
      <div className="flex items-start gap-3">
        <div
          className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
          style={{ background: `${color}22` }}
        >
          <Icon className="w-4 h-4" style={{ color }} strokeWidth={2.5} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm text-white font-medium">
            {isSuccess ? "Tesla account connected" : "Tesla sign-in failed"}
          </div>
          <div className="text-xs text-zinc-400 mt-1 leading-relaxed">
            {isSuccess
              ? "Your battery telemetry will start syncing shortly."
              : `Reason: ${state.reason}. Please try again.`}
          </div>
        </div>
        <button
          onClick={() => setState(null)}
          data-testid="tesla-banner-close"
          className="text-zinc-500 hover:text-white transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
